import { Autocomplete, AutocompleteProps, Box, TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

import { Taxonomy } from 'app/model/taxonomy';
import { selectAvailableTaxonomies } from 'features/auth/auth.slice';

type TaxonomySingleSelectorProps = Omit<AutocompleteProps<Taxonomy, false, boolean, false>, 'options' | 'renderInput'> &
    Pick<TextFieldProps, 'autoFocus' | 'variant'>;

export const TaxonomySingleSelector: React.FunctionComponent<TaxonomySingleSelectorProps> = (props) => {
    const available = useSelector(selectAvailableTaxonomies);

    const { autoFocus, variant, ...rest } = props;

    return (
        <Autocomplete
            options={available}
            getOptionLabel={(tx) => tx.name}
            renderInput={(params) => <TextField {...params} label='Taxonomy' variant={variant} autoFocus={autoFocus} />}
            renderOption={(renderProps, option) => (
                <Box component='li' sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...renderProps}>
                    {/* <img*/}
                    {/*    loading="lazy"*/}
                    {/*    width="20"*/}
                    {/*    src={'https://flagcdn.com/w20/us.png'}*/}
                    {/*    srcSet={'https://flagcdn.com/w40/us.png 2x'}*/}
                    {/*    alt=""*/}
                    {/* />*/}

                    {option.name}
                </Box>
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            {...rest}
        />
    );
};
